import "./OutdoorLiving.module.css";
import Header from "@/reusable_sections/Header";
import OutdoorLiving from "./sections/OutdoorLiving";
import PlanningDecisions from "./sections/PlanningDecisions";
import OutdoorLivingTimeline from "./sections/OutdoorLivingTimeline";
import OutdoorProcess from "./sections/OutdoorProcess";
import OutdoorLivingFaq from "./sections/OutdoorLivingFaq";
import ConsultationCta from "./sections/ConsultationCta";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function OutdoorLivingPage() {
  return <div>
      <Header />
      <OutdoorLiving />
      <PlanningDecisions />
      <OutdoorLivingTimeline />
      <OutdoorProcess />
      <OutdoorLivingFaq />
      <EstimateRequestForm />
      <ConsultationCta />
      <Footer />
    </div>;
}